module.exports = __webpack_public_path__ + "img/T744-C61.4cfd2327.jpg";